export default __webpack_public_path__ + "static/media/failureImg.5a68ed00.png";